// Modules
import { api } from "services/api/service";

// Constants
import {
	API_USER,
	API_GET_GROUP_PERMISSION_LIST,
	API_CREATE_GROUP,
	API_TOGGLE_GROUP_ACTIVATION,
	API_GET_GROUP_LIST,
	API_EDIT_GROUP,
	API_CREATE_ADMIN_USER,
	API_USER_LIST,
	API_DEACTIVATE_ADMIN_USER,
	API_ACTIVATE_ADMIN_USER,
	API_RESEND_TEMPORARY_PASSWORD,
	API_EDIT_ADMIN_USER,
	API_GET_CONFIG_DATA,
	API_GET_STORE_LIST,
	API_UPDATE_WATCHWORD_RESET_LOG,
	API_GET_CARD_ENQUIRY_DETAILS,
	API_GET_MEMBER_ENQUIRY_DETAILS,
	API_DELINK_MEMBER,
	API_INSERT_AUDIT_LOG
} from "constants/api";

// Imported definitions
import type {
	ApiResponse,
	ApiUserResponse,
	GroupPermissionListResponse,
	CreateGroupResponse,
	ToggleGroupActivationResponse,
	GroupListResponse,
	EditGroupResponse,
	CreateUserResponse,
	DeactivateUserResponse,
	ActivateUserResponse,
	ResendTemporaryPasswordResponse,
	EditUserResponse,
	GetConfigDataResponse,
	GetStoreListResponse,
	UpdateWatchwordResetLogResponse,
	CardEnquiryResponse,
	MemberEnquiryResponse,
	DelinkMemberResponse,
	InsertAuditLogResponse
} from "services/api/types";

// API
export const getUsers = async (): Promise<ApiResponse<ApiUserResponse>> => {
	return (await api()).post(API_USER);
};

// This API provide list of all active permissions
export const getGroupPermissionList = async (payload: any): Promise<ApiResponse<GroupPermissionListResponse>> => {
	return (await api()).post(API_GET_GROUP_PERMISSION_LIST, payload);
};

export const getUserList = async (payload: any): Promise<ApiResponse<ApiUserResponse>> => {
	return (await api()).post(API_USER_LIST, payload);
};
// This API creates new group
export const createGroup = async (payload: any): Promise<ApiResponse<CreateGroupResponse>> => {
	return (await api()).post(API_CREATE_GROUP, payload);
};

// This API edits group details
export const editGroup = async (payload: any): Promise<ApiResponse<EditGroupResponse>> => {
	return (await api()).put(API_EDIT_GROUP, payload);
};

// This API Deactivate / activates group
export const toggleGroupActivation = async (payload: any): Promise<ApiResponse<ToggleGroupActivationResponse>> => {
	return (await api()).post(API_TOGGLE_GROUP_ACTIVATION, payload);
};

// API to fetch single group list
export const getGroupList = async (payload: any): Promise<ApiResponse<GroupListResponse>> => {
	return (await api()).post(API_GET_GROUP_LIST, payload);
};

// API to create admin user
export const createUser = async (payload: any): Promise<ApiResponse<CreateUserResponse>> => {
	return (await api()).post(API_CREATE_ADMIN_USER, payload);
};

// API to edit admin user
export const editUser = async (payload: any): Promise<ApiResponse<EditUserResponse>> => {
	return (await api()).post(API_EDIT_ADMIN_USER, payload);
};

// API to deactivateUser admin user
export const deactivateUser = async (payload: any): Promise<ApiResponse<DeactivateUserResponse>> => {
	return (await api()).post(API_DEACTIVATE_ADMIN_USER, payload);
};

// API to activateUser admin user
export const activateUser = async (payload: any): Promise<ApiResponse<ActivateUserResponse>> => {
	return (await api()).post(API_ACTIVATE_ADMIN_USER, payload);
};

// API to resend temporary password for admin user
export const resendTemporaryPassword = async (payload: { username: string }): Promise<ApiResponse<ResendTemporaryPasswordResponse>> => {
	return (await api()).post(API_RESEND_TEMPORARY_PASSWORD, payload);
};

// API to getConfigData
export const getConfigData = async (payload: any): Promise<ApiResponse<GetConfigDataResponse>> => {
	return (await api()).post(API_GET_CONFIG_DATA, payload);
};

// API to getStoreList
export const getStoreList = async (payload: any): Promise<ApiResponse<GetStoreListResponse>> => {
	return (await api()).post(API_GET_STORE_LIST, payload);
};

// API to update Watchword Reset Log
export const updateWatchwordResetLog = async (): Promise<ApiResponse<UpdateWatchwordResetLogResponse>> => {
	return (await api()).post(API_UPDATE_WATCHWORD_RESET_LOG, {});
};

export const insertAuditLog = async (payload: any): Promise<ApiResponse<InsertAuditLogResponse>> => {
	return (await api()).post(API_INSERT_AUDIT_LOG, payload);
};

export const getCardEnquiryDetails = async (payload: any): Promise<ApiResponse<CardEnquiryResponse>> => {
	return (await api()).post(API_GET_CARD_ENQUIRY_DETAILS, payload);
};

export const getMemberEnquiryDetails = async (payload: any): Promise<ApiResponse<MemberEnquiryResponse>> => {
	return (await api()).post(API_GET_MEMBER_ENQUIRY_DETAILS, payload);
};

export const delinkMember = async (payload: any): Promise<ApiResponse<DelinkMemberResponse>> => {
	return (await api()).post(API_DELINK_MEMBER, payload);
};
